// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bHk1","footer":"styles_footer__1HHaq"};